import { render, staticRenderFns } from "./points_year.vue?vue&type=template&id=ebb8b2ec"
import script from "./points_year.vue?vue&type=script&lang=js"
export * from "./points_year.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports